module.exports = __webpack_public_path__ + "static/img/Xeoscript.f4e1db9c.png";